import type { ImageViewerDimensions } from './ImageViewer.types';

export const areDimensionsEqual = (current?: ImageViewerDimensions, next?: ImageViewerDimensions) =>
  current?.width === next?.width && current?.height === next?.height;

export const clampRatio = (value: number) => Math.min(Math.max(value, 0), 1);

export const getImageContainerElement = (imageElement: HTMLImageElement | null) => imageElement?.parentElement ?? null;
